export default __webpack_public_path__ + "static/media/villafago.dc5f2ca7.png";